export default "__VITE_ASSET__cwrqFwJB__"